import ListView from '../../../components/listView/ListView'
import CardList from '../../../components/cardList/CardList'

const routesHome = [
    {
        path: "/home",
        element: CardList,
        props: {
            type: 'appList',
        }
    },
    {
        path: "/home/apps",
        element: CardList,
        props: {
            type: 'appList',
        }
    }
]

export default routesHome
